import {
    GET_MY_VACATIONS,
    OPEN_VACATION_REQUEST,
    CANCEL_VACATION_REQUEST
} from '../actions/vacation';
import _ from 'lodash';

const INITIAL_STATE = [];

export default function (state = INITIAL_STATE, action) {
    let index = -1;
    switch (action.type) {
        case GET_MY_VACATIONS:
            return [].concat(action.value);

        case OPEN_VACATION_REQUEST:
            return [action.value].concat(state);

        case CANCEL_VACATION_REQUEST:
            index = _.findIndex(state, { '_id':  action.value._id});
            state[index] = action.value;
            return [].concat(state);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/vacation.js